import { AnnouncementType } from "../../../components/shared/Announcement";

export interface IAirtableValues {
  announcementKey?: string;
  announcementTitle?: string;
  announcementLink?: string;
  announcementActionTitle?: string;
  dismissable?: number;
  earnAnnouncementKey?: string;
}

export const useGetAnnouncement = (_announcementType: AnnouncementType) => {
  // Temporarily disabled to avoid client-side Airtable Alert/Feature calls.
  return {
    announcementKey: "",
    announcementTitle: "",
    announcementLink: "",
    announcementActionTitle: "",
    dismissable: false,
  };
};
